import { msg } from "@omegagrid/localize";
import { CellRange, ColumnSource, RowSource } from "@omegagrid/grid";
import rp, { GridEditorAdapter, GridEditorOptions, formatBytes } from "@reporting/rp-app-host";
import { DbTable } from "@reporting/rp-types/server";

export class TablesGridAdapter extends GridEditorAdapter {

	private _columns: ColumnSource[];

	constructor(
		private idServer?: number,
		private dbName?: string
	) { super() }

	async getColumns(): Promise<ColumnSource[]> {
		if (this._columns) return this._columns;
		this._columns = [{
			data: 'table_name',
			header: msg('Table'),
			t: 't',
			w: 200,
		}, {
			data: 'partition_number',
			header: msg('Partition'),
			t: 'n',
			w: 100,
		}, { // conditionalFormat 0
			data: 'row_count',
			header: msg('Rows'),
			t: 'n',
			w: 150,
		}, { // conditionalFormat 1
			data: 'used_size',
			header: msg('Used Size'),
			t: 'n',
			w: 200,
		}, { // conditionalFormat 1
			data: 'unused_size',
			header: msg('Unused Size'),
			t: 'n',
			w: 200,
		}, { // conditionalFormat 1
			data: 'total_size',
			header: msg('Total Size'),
			t: 'n',
			w: 200,
		}, { // conditionalFormat 1
			data: 'index_size',
			header: msg('Index Size'),
			t: 'n',
			w: 200,
		}, {
			data: 'ncci',
			header: 'NCCI',
			t: 'b',
			e: false,
			w: 70,
		}, {
			data: 'partitioned',
			header: msg('Partitioning'),
			t: 'b',
			e: false,
			w: 90,
		}];
		return this._columns;
	}

	async getRows(): Promise<RowSource[]> {
		// without a database the server answers with the tables of its default (super) database
		const tables = await rp.ms('server').get<DbTable[]>(`tableStats/${this.idServer}`, this.dbName ? { database: this.dbName } : null);
		return tables.map(data => ({ data: {
			...data,
			used_size: { v: data.used_size, dv: formatBytes(data.used_size) },
			total_size: { v: data.total_size, dv: formatBytes(data.total_size) },
			unused_size: { v: data.unused_size, dv: formatBytes(data.unused_size) },
			index_size: { v: data.index_size, dv: formatBytes(data.index_size) },
		}}));
	}

	afterLoad() {
		if (this.editor.grid.model.rows.length) {
			this.editor.grid.model.conditionalFormats.formats.push({
				key: 'rowsDatabar',
				type: 'bar',
				ranges: [CellRange.fullColumn(2)],
				color: '083B00',
			}, {
				key: 'sizeDatabar',
				type: 'bar',
				ranges: [CellRange.fullColumn(3), CellRange.fullColumn(4), CellRange.fullColumn(5), CellRange.fullColumn(6)],
				color: '003573',
			});
			this.editor.grid.model.clearCalculatedStyles();
		}
	}

	getOptions(): Partial<GridEditorOptions> {
		return this.createOptions({
			colLetters: false,
			columnSorting: true,
			filters: true,
			pageSize: null,
			editable: false,
			lightTheme: null,
			darkTheme: null,
			toolbar: {
				save: {enabled: false},
				discard: {enabled: false},
				new: {enabled: false},
			},
		});
	}

}
